import React from 'react';
import Loadable from 'react-loadable';
import RouteLoading from 'components/RouteLoading';

export default [
  {
    exact: true,
    path: '/home/polymerize/tag',
    owner: '/home',
    // authority: 'tagList',
    component: Loadable({
      loader: () => import('./index'),
      loading: () => <RouteLoading />
    })
  },
];